<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
        </div>
        <div class="cotainer selectPropagateCurrency">
          <div class="info-box">
            <div class="t1">{{$t('bzhl.qtbz')}}</div>
            <div class="t2">{{$t('bzhl.xzbzts')}}</div>
          </div>
          <ul class="ul-box">
              <li class="li" v-for="(item,index) in bzData" :key="index" @click="select(item.name,item.icon)">
                 <template v-if="lang == 'ar'">
                  <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                  <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                  <div class="text">{{item.name | toUp}}</div>
                  <img class="icon" style="margin: 0 0 0 .3rem" :src="item.icon" alt="">
                </template>
                <template v-else>
                  <img class="icon" :src="item.icon" alt="">
                  <div class="text">{{item.name | toUp}}</div>
                  <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                  <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </template>
              </li>
          </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectPropagateCurrency',
    data () {
        return {
            theme: false,
            url: '',
            type: 1,
            bzData: [],
            currency: '',
            lang: 'en'
        }
    },
    created(){
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.currency = localStorage.getItem('sbsxbz') || 'USDT';
        this.url = this.$route.query.url;
        this.type = this.$route.query.type;
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getmarketList();
    },
    methods: {
       back(){
           this.$router.push('/propagate')
       },
       getmarketList(){
           let params = {
               id: 1,
               type: "profit"
           }
           this.$ajax.get('/web/getCurrencyAll',{params}).then((res) => {
                let resData = res.data.data;
                this.bzData = resData.filter(item=>{
                  return (item.name != this.currency.toLowerCase())
                });
            }).catch(function(err){
                console.log(err)
            })
       },
       select(bz,icon){
          localStorage.setItem('sbsxbz',bz.toUpperCase());
          localStorage.setItem('sbsxIcon',icon);
          this.$router.push('/propagate')
       }
    },
    filters:{
      toUp(v){
        return v.toUpperCase()
      }
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .info-box{
      padding: .52rem .48rem .76rem;
      background: #fff;
    }
    .cotainer .info-box .t1{
      color: #000;
      font-size: .65rem;
    }
    .cotainer .info-box .t2{
      padding-top: .6rem;
      color: #696969;
      font-size: .4rem;
    }
    .cotainer .ul-box{
        padding: .35rem .28rem;
        background: #f7f7f7;
    }
    .cotainer .ul-box .li{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .32rem;
        padding: .52rem .32rem;
        background: #fff;
    }
    .cotainer .ul-box .li .icon{
        width: .62rem;
        margin-right: .3rem;
        border-radius: 50%;
    }
     .cotainer .ul-box .li .text{
       flex: 1;
       color: #000;
       font-size: .48rem;
     }
    .cotainer .ul-box .li .arrow{
        width: .22rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/selectPropagateCurrency.vue